import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Let’s go!',
    description:
      'French banking law requires us to check your personal information as an agent. This will only take a few minutes.',
    title: 'We will now ask you some questions about yourself',
  },
  fr: {
    cta: 'C’est parti\u00A0!',
    description:
      'La réglementation bancaire française nous impose de vérifier vos informations personnelles en tant que mandataire. Cela ne dure que quelques minutes.',
    title: 'Continuons par quelques questions vous concernant',
  },
} as const);

export default locales;
